import type { CustomerCardComponentModel } from '@services/api';
import { Card, Space, Typography, Row, Col } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { bxOpenSlider } from '@lib/bx24';
import React, { useState } from 'react';

const { Text } = Typography;

interface Props {
  data?: CustomerCardComponentModel;
}

export default function CustomerLink({ data }: Props) {
  const { displayName, inn, customerId } = data || {};
  const [hovered, setHovered] = useState(false);

  const handleOpen = () => {
    bxOpenSlider('customer', { customerId });
  };

  const baseStyle: React.CSSProperties = {
    cursor: 'pointer',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    borderColor: hovered ? '#1677ff' : undefined,
    boxShadow: hovered
      ? '0 0 0 2px rgba(22, 119, 255, 0.12), 0 6px 16px -8px rgba(22, 119, 255, 0.2)'
      : undefined,
  };

  return (
    <Card
      size="small"
      bordered
      hoverable
      style={baseStyle}
      onClick={handleOpen}
      role="button"
      tabIndex={0}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleOpen();
        }
      }}
    >
      <Space direction="vertical" size={0}>
        <Row justify="space-between" align="middle" wrap={false}>
          <Col flex="auto">
            <Text strong ellipsis={{ tooltip: displayName || '' }}>
              {displayName || '—'}
            </Text>
          </Col>
          <Col>
            <EditOutlined aria-label="Редактировать" />
          </Col>
        </Row>

        {inn && (
          <Text type="secondary" style={{ fontSize: 12 }}>
            ИНН: {inn}
          </Text>
        )}
      </Space>
    </Card>
  );
}
